const color = {
  background: '#F6F5FA',
  park: '#DDE5E2',
  wood: '#E6EAE9',
  water: 'rgba(164, 197, 228, 0.5)',
  buildings: '#E8E8F4',
  roadMinor: '#DEDEEE',
  roadMajorStart: 'rgb(217, 181, 150)',
  roadMajorEnd: 'rgb(225, 216, 43)',
  roadPrimaryStart: '#E4B1B1',
  roadPrimaryEnd: '#FFD02B',
  roadMajorLabel: '#665F77',
  roadMinorLabel: '#665F77',
  placesLabel: '#665F77',
  halo: '#F6F5FA',
  // TODO: (2) Adjust color for relations
  relations: 'rgba(102, 95, 119, 0.5)',
  historicalMap: '#000',
  boundsBorder: '#A39DB0',
  bounding: '#ffdd3d',
  boundingFill: '#ffdd3d',
  boundsFill: '#F6F5FA',
  tint: 'rgba(152, 164, 197, 0.61)',
  colorize: '#665F77',
}

export default color
